module.exports = __webpack_public_path__ + "img/home_icon.b02cb178.svg";